import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

export const fetchSkuMetadata = createAction('[SkuMetadata] - Fetch sku metadata');
export const getSkuMetadataSuccess = createAction('[SkuMetadata] - Get sku metadata', props<{ lastUpdated: Date | undefined, version: string }>());
export const getSkuMetadataFailure = createAction('[SkuMetadata] - Get sku metadata failure', props<{ error: HttpErrorResponse }>());
